export default "__VITE_ASSET__BkIVOB9H__"